import $ from 'jquery';

$(document).ready(function () {
    $('table.make-responsive').wrap('<div class="table-responsive">');
});